/**
 * src/features/router/routes.config.js
 * 
 * Tabla de rutas de la aplicación. Cada ruta define un path y el componente a renderizar.
 */

export const routes = [
    {
        path: '/',
        component: 'InitialPage',
        name: 'initial'
    },
    {
        path: '/directorio',
        component: 'DirectoryPage',
        name: 'directory'
    },
    {
        path: '/directorio/:categoria',
        component: 'DirectoryPage',
        name: 'directory-category'
    },
    {
        path: '/promociones',
        component: 'PromosPage',
        name: 'promos'
    },
    {
        path: '/promociones/:id',
        component: 'PromoDetailPage',
        name: 'promo-detail'
    },
    {
        path: '/contacto',
        component: 'ContactPage',
        name: 'contact'
    },
    {
        path: '/registrar',
        component: 'RegisterPage',
        name: 'register'
    },
    {
        path: '/negocio/:id',
        component: 'BusinessPage',
        name: 'business'
    },
    {
        path: '/admin',
        component: 'AdminPage',
        name: 'admin'
    }
]

/**
 * Obtiene una ruta por su nombre.
 * @param {string} name - El nombre de la ruta.
 * @returns {Object|undefined} La ruta encontrada o undefined.
 */
export function getRouteByName(name) {
    return routes.find(route => route.name === name)
}

/**
 * Genera una URL basada en el nombre de la ruta y parámetros.
 * @param {string} name - El nombre de la ruta.
 * @param {Object} params - Los parámetros de la ruta.
 * @returns {string} La URL generada.
 */
export function generateUrl(name, params = {}) {
    const route = getRouteByName(name)
    if (!route) {
        console.warn(`[ROUTES] Ruta "${name}" no encontrada`)
        return '/'
    }

    let path = route.path
    Object.entries(params).forEach(([key, value]) => {
        path = path.replace(`:${key}`, value)
    })

    return path
}